import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import SignatureCanvas from '@/components/SignatureCanvas.vue';
import Snackbar from '@/components/Snackbar.vue';
import { buildPlaceholderValues } from '@/constants/ContractPlaceholders';
import { getSeasonYear } from '@/store/seasonYear';
let instance = null;
// pdfjs is a heavy dependency; it only loads once a form is actually on screen.
let DocumentSignDialog = class DocumentSignDialog extends Vue {
    open = false;
    signing = false;
    declining = false;
    signature = null;
    targetDate = '';
    targetTemplateId = '';
    pdfUrl = '';
    loadingPdf = false;
    page = 1;
    pageCount = 1;
    /** date is the day the document has to cover, YYYY-MM-DD. */
    static show(date, templateId) {
        if (!instance)
            return;
        instance.targetDate = date;
        instance.targetTemplateId = templateId;
        instance.reset();
        instance.open = true;
    }
    created() {
        instance = this;
    }
    beforeDestroy() {
        if (instance === this)
            instance = null;
    }
    get instructor() {
        return this.$store.getters['instructor/get'](this.$store.getters['user/userId']);
    }
    get template() {
        return this.$store.getters['document/templates']
            .find((t) => t.id === this.targetTemplateId);
    }
    get grade() {
        return this.$store.getters['grade/all'].find((g) => g.id === this.instructor?.data.grade_id);
    }
    get values() {
        if (!this.instructor)
            return {};
        return buildPlaceholderValues(this.instructor.data, this.grade?.data ?? null, getSeasonYear(), this.template?.data ?? {});
    }
    reset() {
        this.signature = null;
        this.signing = false;
        this.declining = false;
        this.page = 1;
        this.pageCount = 1;
        this.pdfUrl = '';
        this.loadPdf();
    }
    async loadPdf() {
        if (!this.template)
            return;
        this.loadingPdf = true;
        try {
            this.pdfUrl = await this.$store.dispatch('document/templatePdfUrl', this.template);
        }
        catch (e) {
            console.error(e);
            Snackbar.error('Formulář se nepodařilo načíst');
        }
        finally {
            this.loadingPdf = false;
        }
    }
    async sign() {
        if (!this.template || !this.signature || this.signing)
            return;
        this.signing = true;
        try {
            await this.$store.dispatch('document/sign', {
                templateId: this.template.id,
                date: this.targetDate,
                signaturePng: this.signature,
            });
            Snackbar.success('Prohlášení bylo podepsáno');
            this.open = false;
        }
        catch (e) {
            console.error(e);
            Snackbar.error(e.message || 'Podpis se nezdařil');
        }
        finally {
            this.signing = false;
        }
    }
    async decline() {
        if (!this.template || this.declining)
            return;
        this.declining = true;
        try {
            await this.$store.dispatch('document/decline', {
                templateId: this.template.id,
                date: this.targetDate,
            });
            Snackbar.success('Prohlášení jste nepodepsali');
            this.open = false;
        }
        catch (e) {
            console.error(e);
            Snackbar.error(e.message || 'Uložení se nezdařilo');
        }
        finally {
            this.declining = false;
        }
    }
    onOpenChange(value) {
        if (!value)
            this.$emit('closed');
    }
};
__decorate([
    Watch('open')
], DocumentSignDialog.prototype, "onOpenChange", null);
DocumentSignDialog = __decorate([
    Component({ components: { SignatureCanvas, PdfFieldCanvas: () => import('@/components/PdfFieldCanvas.vue') } })
], DocumentSignDialog);
export default DocumentSignDialog;
